/**
 * Enhanced glass morphism card styling with gradient border.
 * - Increased opacity (6%) for better prominence against dark backgrounds
 * - White gradient border provides consistent edge definition
 * - Enhanced blur and brightness for depth
 * - Maintains sophisticated aesthetic aligned with UnifiedChip design language
 */
export const glassCardProps = {
  bg: 'rgba(255, 255, 255, 0.035)',
  backdropFilter: 'blur(24px) saturate(180%) brightness(110%)',
  borderRadius: 'lg',
  position: 'relative' as const,
  overflow: 'hidden' as const,
  sx: {
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: 'inherit',
      padding: '1px',
      background: 'linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.05))',
      WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'xor',
      mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      maskComposite: 'exclude',
      pointerEvents: 'none',
    },
  },
};

/**
 * Soft white halo shadow for dark-glass surfaces (e.g. modals) that would
 * otherwise blend into the app's dark backdrop. Layers a grounding depth
 * shadow with a subtle white glow — reads as gentle luminance separating
 * the surface from the page behind it, not a hard border/ring.
 */
export const softGlowBoxShadow =
  '0 8px 32px rgba(0, 0, 0, 0.45), 0 0 1px rgba(255, 255, 255, 0.35), 0 0 60px rgba(255, 255, 255, 0.14)';
